import { UniversalImporterCandidatesPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterCandidatesPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const { data, loading, error } = useQuery(UniversalImporterCandidatesPageDocument, {
    variables: { companyId: company.id },
    fetchPolicy: 'network-only',
  })

  const atsImportersFeatureFlag = data?.features.featuresConnection.nodes.find(
    (featureFlag) => featureFlag.name === 'ats_importers'
  )
  const canImportResources = data?.universalImporter._policies.importResources.can

  const authorized = atsImportersFeatureFlag?.enabled && canImportResources

  return (
    <ResponsivePage.Body authorized={authorized} loading={loading} error={error} showHeader={false}>
      <NuvoImporter importType="candidates_importer" locale={locale} companyId={company.id} />
    </ResponsivePage.Body>
  )
}

export default UniversalImporterCandidatesPage
